<template>
  <div>
    <d-form>
      <d-form-row class="form-group" v-if="!templateMode">
        <d-col cols="12">
          <label>Iniciar a partir de um Template:</label>
          <div class="d-flex align-items-stretch">
            <div class="flex-grow-1">
              <autocomplete
                ref="templateSearch"
                placeholder="Procupar templates pelo nome"
                :items="templates"
                item-show="name"
                :on-input="onInputTemplate"
                :on-select="setSelectedTemplate"
              />
            </div>
            <d-button
              type="button"
              class="btn btn-success ml-2"
              :disabled="!templateToApply"
              @click="confirmApplyTemplate"
            >
              Aplicar Template
            </d-button>
          </div>
          <small class="text-muted" v-if="templateToApply">
            {{ templateLabel }}
          </small>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="12" md="9">
          <label>Nome:</label>
          <d-form-input
            ref="nameInput"
            type="text"
            v-model="model.name"
            :state="hasErrorFiled('name')"
          />
          <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="12" md="3">
          <div v-if="!templateMode">
            <d-checkbox
              toggle
              v-model="model.settings.prioritize_quality"
              class="custom-toggle-sm"
            >
              <span class="mr-1">Modo Alta Densidade</span>
              <i
                id="tooltip-prioritize_quality"
                class="fas fa-info-circle text-muted"
                style="cursor: pointer"
              />
              <d-tooltip target="tooltip-prioritize_quality" placement="top">
                O sistema realizará múltiplas tentativas de encaixe para
                garantir o máximo de palavras cruzadas e evitar espaços vazios.
              </d-tooltip>
            </d-checkbox>
          </div>

          <div>
            <d-checkbox
              toggle
              v-model="model.settings.useCurrentGameReference"
              class="custom-toggle-sm"
            >
              <span class="mr-1">Usar Jogo Atual como Base</span>
              <i
                id="tooltip-use_reference"
                class="fas fa-info-circle text-muted"
                style="cursor: pointer"
              />
              <d-tooltip target="tooltip-use_reference" placement="top">
                Utiliza as posições e direções das perguntas deste jogo como
                gabarito ao gerar novos jogos.
              </d-tooltip>
            </d-checkbox>
          </div>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group align-items-end">
        <d-col cols="12" md="2">
          <label>Tamanho colunas:</label>
          <d-form-input
            type="number"
            min="1"
            v-model.number="model.columns"
            @input="updateTable"
          />
        </d-col>
        <d-col cols="12" md="2">
          <label>Tamanho linhas:</label>
          <d-form-input
            type="number"
            min="1"
            v-model.number="model.rows"
            @input="updateTable"
          />
        </d-col>
        <d-col cols="12" md="2">
          <label>Estilo do jogo:</label>
          <d-select
            v-model="model.settings.puzzleTypeStyle"
            class="form-control"
          >
            <option value="square">Padrão</option>
            <option value="radius">Arredondado</option>
            <option value="times">Font Times</option>
          </d-select>
        </d-col>
        <d-col
          cols="12"
          md="3"
          v-if="model.settings.puzzleTypeStyle == 'radius'"
        >
          <label>Cor da questão:</label>
          <input
            type="color"
            class="form-control"
            style="height: 38px"
            v-model="model.settings.puzzleTitleColor"
            @change="changeColor"
          />
        </d-col>
        <d-col cols="12" md="3">
          <label>Tamanho da fonte:</label>
          <d-select
            v-model="model.settings.puzzleFontSize"
            class="form-control"
            @change="resizeFont"
          >
            <option value="9">9px</option>
            <option value="10">10px</option>
            <option value="11">11px</option>
            <option value="12">12px</option>
          </d-select>
        </d-col>

        <d-col cols="12" md="3" v-if="!templateMode">
          <label>Copiar Layout do Jogo:</label>
          <autocomplete
            ref="gameImportSearch"
            placeholder="Selecione um jogo base..."
            :items="gamesFromTemplate"
            item-show="name"
            :on-input="onSearchGames"
            :on-select="onSelectGameToCopy"
          />
        </d-col>
      </d-form-row>
      <d-form-row
        v-if="!templateMode"
        class="form-group align-items-end bank-controls-row"
      >
        <d-col class="mt-2" cols="6" md="6" lg="6">
          <div class="bank-controls-group">
            <div class="bank-controls-title">Banco de respostas</div>
            <div class="bank-controls-inline">
              <div class="bank-count-field">
                <label>Quantidade:</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  max="10"
                  v-model.number="model.settings.bankAnswersCount"
                  @change="normalizeBankAnswersCount"
                />
              </div>
              <d-button
                type="button"
                class="btn-outline-light border bank-action-button"
                @click="generateBank"
              >
                Gerar
              </d-button>
              <d-button
                type="button"
                class="btn-outline-light border bank-action-button"
                @click="clearBank"
              >
                Limpar
              </d-button>
            </div>
          </div>
        </d-col>
      </d-form-row>
    </d-form>
    <div
      class="puzzle-container"
      @click.self="closeAllModals"
    >
      <puzzle-grid
        ref="mainGrid"
        v-if="model.table.length > 1"
        :table="model.table"
        :rows="model.rows"
        :columns="model.columns"
        :settings="model.settings"
        :cell-size="cellSize"
        :show-answer="showAnswer"
        :show-question="showQuestion"
        :template-mode="templateMode"
        :can-edit-questions="canEditQuestions"
        :is-generating="load"
        :active-scan-cell="activeScanCell"
      />
      <div
        class="bank"
        v-if="model.settings.bank && model.settings.bank.length > 0"
      >
        <span>Banco:</span>
        <ul>
          <li v-for="word in model.settings.bank" :key="word">
            {{ word.length }}/{{ word }}.
          </li>
        </ul>
      </div>
      <puzzle-options />
      <puzzle-option-answer />
      <puzzle-option-question />
      <puzzle-option-ungroup />
      <puzzle-option-arrow />
    </div>
    <div class="w-100 text-center my-2" v-if="canEditQuestions">
      <span>Dê duplo clique nas células para marcar como pergunta</span>
    </div>
    <puzzle-edit-question-modal />
    <import-file-modal @confirm-import="chooseFile" />
    <save-template-modal
      :initial-model="model"
      @confirm="executeSaveAsTemplate"
    />
    <confirmation-modal
      :cancel="closeAlertModal"
      :confirm="callback"
      :title="title"
      :message="message"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { cloneDeep, stringfy } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import Autocomplete from '_common/shared/Autocomplete.vue';
import formatErrors from '_common/mixins/FormatErrors';
import TemplateSearch from '_common/mixins/TemplateSearch';
import Events from '_utils/events';
import DropDown from '_shared/DropDown.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import PuzzleCell from './PuzzleCell.vue';
import PuzzleOptions from './modal/PuzzleSelectOptionModal.vue';
import PuzzleOptionArrow from './modal/PuzzleOptionArrowsModal.vue';
import PuzzleOptionAnswer from './modal/PuzzleOptionAnswerModal.vue';
import PuzzleOptionUngroup from './modal/PuzzleOptionUngroupModal.vue';
import PuzzleOptionQuestion from './modal/PuzzleOptionQuestionModal.vue';
import {
  CELL,
  MODEL,
  _PUZZLE_SET_CELL_,
  _PUZZLE_SET_ANSWER_,
  _PUZZLE_GROUP_OPTION_,
  _PUZZLE_SELECTED_CELL_,
  _PUZZLE_CLOSE_ALL_MODAL_,
  _PUZZLE_PRE_GROUP_OPTION_,
  CELL_SIZE,
  _PUZZLE_SET_QUESTION_,
  _LOAD_MODEL_,
} from './PuzzleModel';
import PuzzleFillTable from './PuzzleFillTable.vue';
import PuzzleEditQuestionModal from './modal/PuzzleEditQuestionModal.vue';
import ImportFileModal from './modal/ImportFileModal.vue';
import PuzzleGrid from './PuzzleGrid.vue';
import SaveTemplateModal from './modal/SaveTemplateModal.vue';

const methodsAvailableForAnswers = {
  top: 'topAnswer', // : ['top','top_right','top_left','top_diagonal_right','top_diagonal_left'],
  left: 'leftAnswer', // : ['left','left_top','left_bottom','left_diagonal_top','left_diagonal_bottom'],
  right: 'rightAnswer', // : ['right', 'right_top', 'right_bottom', 'right_diagonal_top', 'right_diagonal_bottom'],
  bottom: 'bottomAnswer', // : ['bottom','bottom_right','bottom_left','bottom_diagonal_right','bottom_diagonal_left'],
};

export default {
  name: 'puzzle-form',
  props: {
    templateMode: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [PuzzleFillTable, mixin, formatErrors, TemplateSearch],
  components: {
    DropDown,
    PuzzleCell,
    PuzzleOptions,
    ConfirmationModal,
    PuzzleOptionArrow,
    PuzzleOptionAnswer,
    PuzzleOptionUngroup,
    PuzzleOptionQuestion,
    PuzzleEditQuestionModal,
    Autocomplete,
    ImportFileModal,
    PuzzleGrid,
    SaveTemplateModal,
  },
  computed: {
    ...mapState({
      puzzle: state => {
        state.puzzle = this.model;
        return state;
      },
      templateLabel() {
        if (!this.templateToApply) return '';

        const { name, rows, columns } = this.templateToApply;

        return `Selecionado: ${name} (${rows}x${columns})`;
      },
    }),
    load() {
      const Loading = this.$store.state.toggle.progress;
      if (Loading) {
        return Loading;
      }
      return false;
    },
    cellSize() {
      return CELL_SIZE;
    },
    showAnswer() {
      const { printAnswer } = this.$store.state.puzzle;
      return printAnswer;
    },
    showQuestion() {
      const { printQuestion } = this.$store.state.puzzle;
      return printQuestion;
    },
    puzzlePreview() {
      const { puzzlePreviewData } = this.$store.state.puzzle;
      return puzzlePreviewData;
    },
    canEditQuestions() {
      if (!this.model.is_template) return false;

      return this.templateMode || !this.model.id || this.model.is_template;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      title: 'Confirmação',
      callback: null,
      fileUpload: null,
      message: 'Tem certeza que deseja continuar?',
      templateToApply: null,
      isApplyingTemplate: false,
      activeScanCell: { x: 0, y: 0 },
      gamesFromTemplate: [],
      gameBase: null,
      errors: {
        name: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setPuzzle',
      'setToggle',
      'activeAlert',
      'setPuzzleCell',
      'setPuzzlePreviewData',
      'setHasChanges',
      'progress',
    ]),
    onSearchGames(term) {
      const params = {
        template_id: this.model.template_id,
        slug: 'palavra-cruzadas',
        skip: 0,
        take: 10,
        search: term,
      };

      PuzzleService.getPuzzles(params)
        .then(response => {
          this.gamesFromTemplate = response.list;
        })
        .catch(err => {
          console.error('Erro ao buscar jogos para importação:', err);
        });
    },
    onSelectGameToCopy(game) {
      if (!game || !game.table) return;

      this.gameBase = game;
      this.importLayout();
    },
    importLayout() {
      const newTable = [...this.gameBase.table];

      newTable.forEach(cell => {
        if (cell.isQuestion || cell.children.length) {
          cell.id = null;
          cell.question_id = null;

          if (cell.children && cell.children.length > 0) {
            cell.children.forEach(subCell => {
              if (subCell) {
                cell.id = null;
                subCell.text = null;
                subCell.question_id = null;
              }
            });
          }
        }

        cell.text = null;
      });

      this.model.table = newTable;
      this.model.columns = this.gameBase.columns;
      this.model.rows = this.gameBase.rows;

      this.activeAlert({
        message: 'Layout e coordenadas das dicas importados com sucesso!',
        theme: 'success',
      });
    },
    onTemplateCleared() {
      if (this.templateToApply) {
        this.templateToApply = null;
        this.$refs.templateSearch.$refs.input.value = '';
      }
    },
    setSelectedTemplate(template) {
      if (template) {
        this.templateToApply = template;
        this.model.template_id = template.id;
      }
    },
    confirmApplyTemplate() {
      if (!this.templateToApply) return;

      this.alertModal(
        'Confirmar Mudança',
        `Deseja carregar o grid de "${this.templateToApply.name}"? Isso substituirá suas linhas e colunas atuais.`,
        this.applyTemplate,
      );
    },
    confirmSaveAsTemplate() {
      this.alertModal(
        'Criar Novo Template',
        'Deseja salvar a estrutura atual (posições das perguntas) como um novo template? As letras atuais serão limpas no template salvo.',
        this.save,
      );
    },
    applyTemplate() {
      this.isApplyingTemplate = true;
      this.model.rows = this.templateToApply.rows;
      this.model.columns = this.templateToApply.columns;
      this.model.table = cloneDeep(this.templateToApply.table);
      this.model.is_template = true;
      this.setPuzzle(this.model);

      this.closeAlertModal();

      this.activeAlert({
        message: 'Template aplicado com sucesso!',
        theme: 'success',
      });

      this.$nextTick(() => {
        this.isApplyingTemplate = false;
      });
    },
    addNewCell(table, row, column) {
      table.push({
        ...cloneDeep(CELL),
        ...{
          positionx: row.toString(),
          positiony: column.toString(),
          isQuestion: false,
        },
      });
    },
    chooseFile(file) {
      this.fileUpload = file;

      setTimeout(() => {
        this.setTablaByFile();
      }, 20);
    },
    setTablaByFile() {
      const template = this.fileUpload.trim().split('\n');
      this.model.rows = template.length;
      this.model.columns = template[0].replace(/(\r)/gm, '').length;
      this.model.table = [];
      template.forEach((row, r) => {
        const columns = row.trim();
        Array.from(columns).forEach((cell, c) => {
          if (cell === '.') {
            this.model.table.push({
              ...cloneDeep(CELL),
              ...{ positionx: c, positiony: r },
            });
          } else {
            this.model.table.push({
              ...cloneDeep(CELL),
              ...{
                text: cell,
                isAnswer: true,
                positionx: c,
                positiony: r,
              },
            });
          }
        });
      });
      this.setPuzzle(this.model);
    },
    alertModal(
      title,
      message,
      callback = () => {
        this.respo = true;
      },
    ) {
      this.title = title;
      this.message = message;
      this.callback = callback;
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    closeAlertModal() {
      this.respo = false;
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    closeAllModals() {
      this.unselectAllSiblingsCells(this.model.table, CELL);
      Events.$emit(_PUZZLE_SELECTED_CELL_, CELL);
      this.setPuzzleCell(cloneDeep(CELL));
    },
    errorAlert(error) {
      if (error._isUserCancellation || error.name === 'CanceledError') {
        this.activeAlert({
          message: 'Solicitação cancelada pelo usuário',
          theme: 'info',
        });
        return;
      }

      this.activeAlert({
        message: 'Não foi possível preencher a resposta',
        theme: 'danger',
      });
      console.error('erro: ', error);
    },
    drawTable() {
      this.model.table = [];
      for (let r = 0; r < this.model.rows; r += 1) {
        for (let c = 0; c < this.model.columns; c += 1) {
          this.model.table.push({
            ...cloneDeep(CELL),
            ...{ positionx: c, positiony: r },
          });
        }
      }
      this.setPuzzle(this.model);
    },
    updateTable() {
      if (!this.isApplyingTemplate) {
        this.onTemplateCleared();
      }
      const newTable = [];

      for (let r = 0; r < this.model.rows; r += 1) {
        for (let c = 0; c < this.model.columns; c += 1) {
          const existingCell = this.model.table.find(
            item =>
              Number(item.positionx) === c && Number(item.positiony) === r,
          );

          if (existingCell) {
            newTable.push(existingCell);
          } else {
            newTable.push({
              ...cloneDeep(CELL),
              ...{ positionx: c.toString(), positiony: r.toString() },
            });
          }
        }
      }

      this.model.table = newTable;

      if (this.setPuzzle) {
        this.setPuzzle(this.model);
      }
    },
    normalizeBankAnswersCount(event) {
      const currentValue = event && event.target
        ? event.target.value
        : this.model.settings.bankAnswersCount;

      if (
        currentValue === undefined
        || currentValue === null
        || currentValue === ''
      ) {
        this.$set(this.model.settings, 'bankAnswersCount', 3);
        return;
      }

      const normalizedValue = Number(currentValue);

      if (Number.isNaN(normalizedValue)) {
        this.$set(this.model.settings, 'bankAnswersCount', 3);
        return;
      }

      const clampedValue = Math.min(10, Math.max(0, normalizedValue));
      this.$set(this.model.settings, 'bankAnswersCount', clampedValue);
    },
    getUniqueAnswers(minLength) {
      const validAnswers = this.model.table
        .filter(item => item?.answer?.answer != null && item.answer.answer.length >= minLength)
        .map(item => item.answer.answer);

      return [...new Set(validAnswers)];
    },
    generateBank() {
      this.normalizeBankAnswersCount();
      const requestedCount = Number(this.model.settings.bankAnswersCount) || 0;
      const uniqueAnswers = this.getUniqueAnswers(4);

      if (requestedCount === 0) {
        this.$set(this.model.settings, 'bank', []);
        return;
      }

      if (uniqueAnswers.length < requestedCount) {
        this.activeAlert({
          message: `Não há ${requestedCount} respostas únicas disponíveis com mais de 3 letras nesse jogo.`,
          theme: 'danger',
        });
        this.$set(this.model.settings, 'bank', uniqueAnswers);
        return;
      }

      const generatedBank = uniqueAnswers
        .sort(() => 0.5 - Math.random())
        .slice(0, requestedCount);

      this.$set(this.model.settings, 'bank', generatedBank);
    },
    clearBank() {
      this.model.settings.bank = [];
    },
    resizeFont() {
      this.resizeCellSettingsFontSize(this.model.table);
    },
    changeColor() {
      this.changeCellSettingsColor(this.model.table);
      this.$refs.mainGrid.reRenderCells();
    },
    changeCellSettingsColor(array) {
      return array.map(cell => {
        cell.settings.background = this.puzzleTyleColor;
        cell.updated = true;
        if (cell.children.length) {
          this.changeCellSettingsColor(cell.children);
        }
        return cell;
      });
    },
    resizeCellSettingsFontSize(array) {
      return array.map(cell => {
        cell.settings.font_size = this.puzzleFontSize;
        cell.updated = true;
        if (cell.children.length) {
          this.resizeCellSettingsFontSize(cell.children);
        }
        return cell;
      });
    },
    setCharacterInCell(position, char, answerId = null) {
      this.model.table[position].text = char.toUpperCase();
      this.model.table[position].isAnswer = char !== '';
      this.model.table[position].answer_id = answerId;
      this.model.table[position].updated = true;
    },
    getIndexCellValue(cell) {
      const index = this.getCellIndex(cell);
      if (Number.isNaN(Number(cell.positiony))) {
        let indexChild = null;
        this.model.table[index].children.map((item, cellIndex) => {
          if (item.positiony === cell.positiony) {
            indexChild = cellIndex;
            return cellIndex;
          }
          if (item.children.length > 0) {
            const itemChild = item.children.findIndex(
              child => child.positiony === cell.positiony,
            );
            if (itemChild > -1) {
              indexChild = `${cellIndex}_${itemChild}`;
              return `${cellIndex}_${itemChild}`;
            }
          }
          return false;
        });
        return { index, childIndex: indexChild };
      }
      return { index, childIndex: null };
    },
    setAnswer(cell) {
      const { index, childIndex } = this.getIndexCellValue(cell);
      const directions = cell.direction ? cell.direction.slug.split('_') : [];
      if (directions.length) {
        this[methodsAvailableForAnswers[directions[0]]](
          index,
          directions,
          childIndex,
        );
      }
    },
    setQuestion(cell) {
      if (Number.isNaN(Number(cell.positiony))) {
        const index = this.getCellIndex(cell);
        const indexChild = this.model.table[index].children.findIndex(
          item => item.positiony === cell.positiony,
        );
        this.model.table[index].children[indexChild] = cell;
      } else {
        this.getIndexCellValue(cell);
      }
    },
    unselectAllSiblingsCells(array, selected) {
      array.forEach(cell => {
        if (cell !== selected) {
          cell.active = false;
        }
        if (cell.children && cell.children.length > 0) {
          this.unselectAllSiblingsCells(cell.children, selected);
        }
      });
    },
    errorMerge(initial, message) {
      this.activeAlert({ message, theme: 'danger' });
      this.unselectAllSiblingsCells(this.model.table, initial);
      this.setPuzzleCell(cloneDeep(CELL));
      initial.active = false;
      return false;
    },
    mergeCells(initial, final) {
      if (final.type !== 'col') {
        return this.errorMerge(
          initial,
          'Não é possivel mesclar uma outra célula mesclada',
        );
      }
      if (initial.positionx === final.positionx) {
        return this.mergeVertical(initial, final);
      }
      if (initial.positiony === final.positiony) {
        return this.mergeHorizontal(initial, final);
      }
      return this.errorMerge(
        initial,
        'Só é possivel mesclar células na horizontal ou vertical',
      );
    },
    checkValidCellsHorizontalToMerge(position, cell) {
      if (this.model.table[position].positiony === cell.positiony) {
        this.model.table[position].active = true;
      }
    },
    checkValidCellsVerticalToMerge(position) {
      if (this.model.table[position]) {
        this.model.table[position].active = true;
      }
    },
    selectValidCellsToMerge(cell) {
      const index = this.getCellIndex(cell);
      const { columns } = this.model;
      this.model.table[index].active = true;
      this.checkValidCellsHorizontalToMerge(index + 1, cell);
      this.checkValidCellsHorizontalToMerge(index - 1, cell);
      this.checkValidCellsVerticalToMerge(index + columns);
      this.checkValidCellsVerticalToMerge(index - columns);
    },
    getIndexToMerge(initial, final, field = 'positionx') {
      const side = final[field] - initial[field];
      return {
        total: side > 0 ? 1 : -1,
        index: this.getCellIndex(initial),
      };
    },
    changeOrderMergeCell(initial, final, position = 'positionx') {
      if (initial[position] > final[position]) {
        return { first: final, second: initial };
      }
      return { first: initial, second: final };
    },
    mergeHorizontal(initial, final) {
      const { first, second } = this.changeOrderMergeCell(
        initial,
        final,
        'positionx',
      );
      const { total, index } = this.getIndexToMerge(first, second, 'positionx');
      this.model.table[index].type = 'colspan';
      this.$set(this.model.table, index + total, {
        ...cloneDeep(CELL),
        ...{
          id: second.id,
          positionx: second.positionx,
          positiony: second.positiony,
          hide: true,
          updated: true,
        },
      });
      this.unselectAllSiblingsCells(this.model.table, initial);
      this.setPuzzleCell(cloneDeep(CELL));
      return initial;
    },
    mergeVertical(initial, final) {
      const { first, second } = this.changeOrderMergeCell(
        initial,
        final,
        'positiony',
      );
      const { total, index } = this.getIndexToMerge(first, second, 'positiony');
      const row = this.model.columns * total;
      let top = index + row;
      let bottom = index;
      if (row > 0) {
        top = index;
        bottom = index + row;
      }
      this.model.table[top].type = 'rowspan';
      this.$set(this.model.table, bottom, {
        ...cloneDeep(CELL),
        ...{
          id: second.id,
          positionx: second.positionx,
          positiony: second.positiony,
          hide: 1,
          updated: true,
        },
      });
      this.unselectAllSiblingsCells(this.model.table, initial);
      this.setPuzzleCell(cloneDeep(CELL));
      return initial;
    },
    async save(options = {}) {
      if (!this.checkForm()) return null;

      this.$store.commit('setToggle', {
        type: 'is_allowed_to_cancel',
        bool: true,
      });
      this.simulateThinking();

      this.model.slug = stringfy(this.model.name);

      const isVariation = options.generate_variation || false;
      const payload = {
        ...this.model,
        template_id: this.templateToApply?.id || this.model.template_id,
        generate_variation: isVariation,
        ...options,
      };

      if (isVariation) {
        const crosswordData = this.prepareCrosswordPayload();
        payload.questions = crosswordData.questions;
        payload.options = crosswordData.options;
      }

      try {
        return await PuzzleService.save(payload);
      } catch (error) {
        const errors = this.formatErrors(error.data);
        this.activeAlert({ message: errors, theme: 'danger' });
        throw error;
      } finally {
        this.setHasChanges(false);
        this.$store.commit('setToggle', {
          type: 'is_allowed_to_cancel',
          bool: false,
        });
      }
    },
    executeSaveAsTemplate(name) {
      try {
        const templateModel = cloneDeep(this.model);

        templateModel.id = null;
        templateModel.name = name;
        templateModel.slug = stringfy(name);
        templateModel.is_template = true;

        templateModel.table = templateModel.table.map(cell => {
          const cleanCell = {
            ...cell,
            text: '',
            isAnswer: false,
            answer_id: null,
            active: false,
          };

          if (cleanCell.children && cleanCell.children.length > 0) {
            cleanCell.children = cleanCell.children.map(child => ({
              ...child,
              text: '',
              isAnswer: false,
              answer_id: null,
            }));
          }

          return cleanCell;
        });

        PuzzleService.save(templateModel).then(response => {
          this.templateToApply = response;
          this.$refs.templateSearch.$refs.input.value = response.name;
        });

        this.activeAlert({
          message: 'Template salvo e selecionado para uso!',
          theme: 'success',
        });

        this.getTemplates('');
      } catch (error) {
        const errors = this.formatErrors(error.data);
        this.activeAlert({ message: errors, theme: 'danger' });
      }
    },
    resetTemplateQuestions() {
      this.model.table.forEach(cell => {
        cell.isQuestion = false;
        cell.updated = true;
      });

      this.activeAlert({
        message:
          'O template foi limpo: todas as marcações de questão foram removidas',
        theme: 'success',
      });
    },
    prepareCrosswordPayload() {
      const questions = [];

      const hasGameBase = this.gameBase !== null;
      const keepArrows = hasGameBase
        ? true
        : this.model.settings.useCurrentGameReference || false;

      function hasConfig(cell) {
        return (
          cell &&
          cell.arrow_position &&
          cell.arrow_position.id &&
          cell.arrow_direction &&
          cell.arrow_direction.id &&
          cell.direction &&
          cell.direction.slug
        );
      }

      this.model.table.forEach(cell => {
        const parentHasConfig = hasConfig(cell);
        const children = [];
        const hasChildren = cell.children && cell.children.length > 0;

        if (keepArrows && hasChildren) {
          cell.children.forEach(child => {
            if (hasConfig(child) || cell.isQuestion) {
              children.push({
                positiony: child.positiony,
                arrow_position: child.arrow_position,
                arrow_direction: child.arrow_direction,
                direction: child.direction,
              });
            }
          });
        }

        if (cell.isQuestion || parentHasConfig || hasChildren) {
          questions.push({
            positionx: Number(cell.positionx),
            positiony: this.normalizeY(cell.positiony),

            arrow_position:
              keepArrows && parentHasConfig ? cell.arrow_position : null,
            arrow_direction:
              keepArrows && parentHasConfig ? cell.arrow_direction : null,
            direction: keepArrows && parentHasConfig ? cell.direction : null,

            children,
          });
        }
      });

      const preparedTable = this.model.table.map(cell => ({
        positionx: Number(cell.positionx),
        positiony: Number(cell.positiony),
      }));

      return {
        rows: Number(this.model.rows),
        columns: Number(this.model.columns),
        questions,
        table: preparedTable,
        options: {
          prioritize_quality: this.model.settings.prioritize_quality,
        },
      };
    },
    normalizeY(value) {
      if (typeof value === 'number') return value;

      if (typeof value === 'string') {
        if (value.indexOf('_') !== -1) {
          return Number(value.split('_')[0]);
        }
        return Number(value);
      }

      return 0;
    },
    generateCrosswordFromGrid() {
      this.$store.commit('setToggle', {
        type: 'is_allowed_to_cancel',
        bool: true,
      });
      this.simulateThinking();

      const payload = this.prepareCrosswordPayload();
      this.model.table = payload.table;

      PuzzleService.generatePuzzle('palavra-cruzadas', payload)
        .then(response => {
          this.model = {
            ...this.model,
            ...response,
          };
          this.setPuzzle(this.model);
          this.gameBase = null;
          this.model.is_template = false;
        })
        .catch(err => {
          console.error('erro ao gerar crossword:', err);
          this.errorAlert(err);
        })
        .finally(() => {
          this.setHasChanges(true);
          this.generateBank();
          this.$store.commit('setToggle', {
            type: 'is_allowed_to_cancel',
            bool: false,
          });
        });
    },
    simulateThinking() {
      this.activeScanCell.x = Math.floor(Math.random() * this.model.columns);
      this.activeScanCell.y = Math.floor(Math.random() * this.model.rows);

      setTimeout(this.simulateThinking, 300);
    },
    focusName() {
      this.$nextTick(() => {
        const input = this.$refs.nameInput?.$el;
        input.focus();
      });
    },
    async saveAndRegenerate() {
      if (this.load) return;

      if (this.gameBase) {
        this.activeAlert({
          message: 'Não é possível salvar e gerar variação enquanto um Layout Base estiver importado. Preencha as palavras primeiro ou limpe o layout.',
          theme: 'warning',
        });
        return;
      }

      if (!this.templateToApply && !this.model.template_id) {
        this.activeAlert({
          message: 'Salve este jogo como template antes de gerar novos jogos.',
          theme: 'warning',
        });
        return;
      }
      this.simulateThinking();

      try {
        const saved = await this.save({ generate_variation: true });

        if (saved && saved.preview) {
          this.setPuzzlePreviewData({ ...saved.preview, template_id: saved.template_id });

          this.activeAlert({
            message: 'Jogo salvo! Carregando a nova variação gerada...',
            theme: 'success',
          });

          if (this.$route.name !== 'admin-crossword-new') {
            this.$router.push({ name: 'admin-crossword-new' });
          } else {
            this.loadPreviewFromStore();
          }
        }
      } catch (err) {
        console.error('Erro:', err);
      }
    },
    async handleNormalSave() {
      const response = await this.save({ generate_variation: false });

      if (response) {
        this.activeAlert({
          message: 'Jogo salvo com sucesso!',
          theme: 'success',
        });

        if (this.$route.name === 'admin-crossword-new') {
          this.$router.push({
            name: 'admin-puzzle-edit',
            params: { puzzleId: response.id },
          });
        }
      }
    },
    loadPreviewFromStore() {
      if (this.puzzlePreview.table) {
        this.model.name = null;
        this.model.rows = this.puzzlePreview.rows;
        this.model.columns = this.puzzlePreview.columns;
        this.model.template_id = this.puzzlePreview.template_id;
        this.model.table = [...this.puzzlePreview.table];

        this.setPuzzlePreviewData(null);
        this.focusName();
        this.generateBank();
      }
    },
    changeStatus(newStatus) {
      PuzzleService.updateStatus([this.model.id], newStatus)
        .then(() => {
          this.activeAlert({
            message: 'Status atualizado com sucesso!',
            theme: 'success',
          });
          this.setPuzzle({ ...this.model, status: newStatus });
        })
        .catch(error => {
          const errors = this.formatErrors(error.data);
          this.activeAlert({ message: errors, theme: 'danger' });
        });
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_SELECTED_CELL_);
    Events.$off(_PUZZLE_SET_ANSWER_);
    Events.$off(_PUZZLE_SET_CELL_);
    Events.$off(_PUZZLE_SET_QUESTION_);
    Events.$off(_PUZZLE_PRE_GROUP_OPTION_);
    Events.$off(_PUZZLE_GROUP_OPTION_);
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    this.normalizeBankAnswersCount();

    if (this.puzzlePreview) {
      this.loadPreviewFromStore();
    } else {
      this.drawTable();
      this.model.is_template = true;
    }

    Events.$on(_PUZZLE_SELECTED_CELL_, cell => {
      Events.$emit(_PUZZLE_CLOSE_ALL_MODAL_);
      this.unselectAllSiblingsCells(this.model.table, cell);
    });
    Events.$on(_PUZZLE_SET_ANSWER_, cell => {
      this.setAnswer(cell);
    });
    Events.$on(_PUZZLE_SET_CELL_, cell => {
      const { index } = this.getIndexCellValue(cell);
      this.$set(this.model.table, index, cell);
    });
    Events.$on(_PUZZLE_SET_QUESTION_, cell => {
      this.setQuestion(cell);
      if (this.model.id) this.save({ generate_variation: false });
    });
    Events.$on(_PUZZLE_PRE_GROUP_OPTION_, cell => {
      this.selectValidCellsToMerge(cell);
    });
    Events.$on(_PUZZLE_GROUP_OPTION_, cell => {
      const { puzzleCell } = this.$store.state.puzzle;
      this.mergeCells(puzzleCell, cell);
    });
    Events.$on(_LOAD_MODEL_, model => {
      const settings = {
        ...this.model.settings,
        ...(model.settings || {}),
      };
      this.model = { ...model, settings };
      this.normalizeBankAnswersCount();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/puzzle';

.bank-controls-row {
  margin-top: -0.25rem;
}

.bank-controls-group {
  border: 1px solid #e1e5eb;
  border-radius: 0.5rem;
  padding: 0.75rem 0.875rem 0.875rem;
  background: #fafbfc;
}

.bank-controls-title {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #3d5170;
}

.bank-controls-inline {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: nowrap;
  width: 100%;
}

.bank-count-field {
  flex: 1 1 0;
}

.bank-count-field label {
  display: block;
  margin-bottom: 0.35rem;
}

.bank-count-field .form-control {
  width: 100%;
}

.bank-action-button {
  flex: 1 1 0;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  background: #ffffff;
  color: #495057;
}

.bank-action-button:hover,
.bank-action-button:focus {
  background: #f3f5f7;
  color: #212529;
}
</style>
